<div class="search-wrapper map-control-btn">
  <i class="fa fa-search"></i>
  <input #address_search
    class="search-input"
    placeholder="Въведете адрес или обект тук..."
  />
</div>
